import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BottomSheet } from '../../../bottom-sheet/esm';
import { FormControlMobile } from '../../../form-control/esm/mobile';
import { ModalMobile } from '../../../modal/esm/mobile';
import { Arrow } from '../components/arrow/Component.js';
import { BaseSelect } from '../components/base-select/Component.js';
import { Field } from '../components/field/Component.js';
import { Footer } from '../components/footer/Component.js';
import { Optgroup } from '../components/optgroup/Component.js';
import 'classnames';
import '../../../badge/esm';
import '../../../checkbox/esm';
import '@alfalab/icons-glyph/CheckmarkCircleMIcon';
import '@alfalab/icons-glyph/CheckmarkMIcon';
import { OptionResponsive } from '../components/option/Component.responsive.js';
import { OptionsList } from '../components/options-list/Component.js';
import { Search } from '../components/search/Component.js';
import { VirtualOptionsList } from '../components/virtual-options-list/Component.js';
import { u as useSelectWithApply } from '../hook-e31cdcb4.js';
import { Header } from '../presets/useSelectWithApply/options-list-with-apply/header/Component.js';
import '@alfalab/icons-glyph/ChevronDownMIcon';
import '@alfalab/icons-glyph/ChevronDownSIcon';
import 'react-merge-refs';
import '@juggle/resize-observer';
import 'compute-scroll-into-view';
import 'downshift';
import '../../../shared/esm';
import '@alfalab/hooks';
import '../utils.js';
import '../components/native-select/Component.js';
import '../components/base-select/components/list-desktop/helpers/get-list-popover-desktop-props.js';
import '../list-popover-desktop-c68b8ae8.js';
import '../components/base-select/components/list-mobile/helpers/get-list-modal-mobile-props.js';
import '../components/base-select/components/list-mobile/helpers/get-list-bottom-sheet-mobile-props.js';
import '../components/base-select/components/list-mobile/list-mobile.js';
import '../components/base-select/components/list-mobile/list-bottom-sheet-mobile.js';
import '../mobile.module-2122fcd6.js';
import '../components/base-select/components/list-mobile/list-modal-mobile.js';
import '../components/clear-button/Component.js';
import '../../../button/esm';
import '@alfalab/icons-glyph/CrossCircleMIcon';
import '@alfalab/icons-glyph/CrossCircleSIcon';
import '../../../base-modal/esm';
import '../../../button/esm/mobile';
import '../consts.js';
import '../components/option/desktop/Component.js';
import '../components/checkmark/Component.js';
import '../components/option/Component.js';
import '../components/option/mobile/Component.js';
import '../components/checkmark-mobile/Component.js';
import '../../../mq/esm';
import '../../../scrollbar/esm';
import '../../../input/esm';
import '@alfalab/icons-glyph/MagnifierMIcon';
import 'react-virtual';
import 'react-fast-compare';
import '../presets/useSelectWithApply/options-list-with-apply/footer/Component.js';
import '../../../button/esm/desktop';

var VIRTUAL_OPTIONS_LIST_THRESHOLD = 30;
var SelectMobile = forwardRef(function (_a, ref) {
    var _b = _a.autocomplete, autocomplete = _b === void 0 ? false : _b, _c = _a.multiple, multiple = _c === void 0 ? false : _c, _d = _a.allowUnselect, allowUnselect = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.closeOnSelect, closeOnSelect = _f === void 0 ? !multiple : _f, _g = _a.circularNavigation, circularNavigation = _g === void 0 ? false : _g, _h = _a.defaultOpen, defaultOpen = _h === void 0 ? false : _h, openProp = _a.open, _j = _a.size, size = _j === void 0 ? 56 : _j, _k = _a.optionsSize, optionsSize = _k === void 0 ? 56 : _k, _l = _a.fieldProps, fieldProps = _l === void 0 ? {} : _l, _m = _a.optionProps, optionProps = _m === void 0 ? {} : _m, _o = _a.optionsListProps, optionsListProps = _o === void 0 ? {} : _o, _p = _a.Arrow, Arrow$1 = _p === void 0 ? Arrow : _p, _q = _a.Field, Field$1 = _q === void 0 ? Field : _q, _r = _a.Optgroup, Optgroup$1 = _r === void 0 ? Optgroup : _r, _s = _a.Option, Option = _s === void 0 ? OptionResponsive : _s, _t = _a.Search, Search$1 = _t === void 0 ? Search : _t, selected = _a.selected, options = _a.options, _u = _a.OptionsList, OptionsList$1 = _u === void 0 ? options.length > VIRTUAL_OPTIONS_LIST_THRESHOLD
        ? VirtualOptionsList
        : OptionsList : _u, onChange = _a.onChange, _v = _a.showClear, showClear = _v === void 0 ? true : _v, showSelectAll = _a.showSelectAll, showHeaderWithSelectAll = _a.showHeaderWithSelectAll, _w = _a.useWithApplyHook, useWithApplyHook = _w === void 0 ? multiple : _w, showSearch = _a.showSearch, searchProps = _a.searchProps, restProps = __rest(_a, ["autocomplete", "multiple", "allowUnselect", "disabled", "closeOnSelect", "circularNavigation", "defaultOpen", "open", "size", "optionsSize", "fieldProps", "optionProps", "optionsListProps", "Arrow", "Field", "Optgroup", "Option", "Search", "selected", "options", "OptionsList", "onChange", "showClear", "showSelectAll", "showHeaderWithSelectAll", "useWithApplyHook", "showSearch", "searchProps"]);
    var applyProps = useSelectWithApply({
        optionsListProps: __assign(__assign({}, optionsListProps), { Footer: Footer }),
        OptionsList: OptionsList$1,
        showSearch: showSearch,
        searchProps: searchProps,
        selected: selected,
        options: options,
        onChange: onChange,
        showClear: showClear,
        showSelectAll: showSelectAll,
    });
    var bottomAddons = function (flatOptions) {
        return flatOptions.length > 0 &&
            useWithApplyHook &&
            showHeaderWithSelectAll && (React.createElement(Header, __assign({}, applyProps.optionsListProps.headerProps, { mobile: true })));
    };
    return (React.createElement(BaseSelect, __assign({ ref: ref, view: 'mobile', autocomplete: autocomplete, multiple: multiple, allowUnselect: allowUnselect, disabled: disabled, closeOnSelect: closeOnSelect, circularNavigation: circularNavigation, defaultOpen: defaultOpen, open: openProp, size: size, optionsSize: optionsSize, fieldProps: __assign({ FormControlComponent: FormControlMobile }, fieldProps), optionProps: optionProps, Arrow: Arrow$1, Field: Field$1, Optgroup: Optgroup$1, Option: Option, Search: Search$1, options: options, selected: selected, onChange: onChange, OptionsList: OptionsList$1, showSearch: showSearch, searchProps: searchProps, BottomSheet: BottomSheet, ModalMobile: ModalMobile, optionsListProps: optionsListProps }, restProps, (restProps.isBottomSheet === false
        ? {
            modalHeaderProps: __assign({ bottomAddons: bottomAddons }, restProps.modalHeaderProps),
        }
        : {
            bottomSheetProps: __assign({ bottomAddons: bottomAddons }, restProps.bottomSheetProps),
        }), (useWithApplyHook && applyProps))));
});

export { SelectMobile };
